import React from "react"

class LocationContent extends React.Component {
  render() {
    return (
      <div>
        <article className="pfb-longform-container">
          <div className="pfb-longform-metadata"> { this.props.category } </div>
          <h2 className="pfb-longform-title"> { this.props.title } </h2>
          <p className="pfb-longform-para"> { this.props.story } </p>
        </article>
      </div>
    )
  }
}

export default LocationContent

/*
export const LocationData = graphql`
  query LocationsJson {
    id
    title
    location
    description
  }
`;
*/


// WEBPACK FOOTER //
// ./src/components/LocationContent/index.js